import { IoLogoWhatsapp } from 'react-icons/io5';
import { FaTwitter, FaLinkedinIn } from 'react-icons/fa';
import { BsInstagram } from 'react-icons/bs';
import { SiGithub } from 'react-icons/si';

export const socialLinks = [
  {
    id: 1,
    url: 'https://wa.me/254743721907',
    icon: <IoLogoWhatsapp />,
  },
  {
    id: 2,
    url: 'https://twitter.com/ken__white',
    icon: <FaTwitter />,
  },
  {
    id: 3,
    url: 'https://www.instagram.com/__whitish__/',
    icon: <BsInstagram />,
  },
  {
    id: 4,
    url: 'https://github.com/KenWhite02',
    icon: <SiGithub />,
  },
  {
    id: 5,
    url: 'https://www.linkedin.com/in/ken-white-3008701b9/',
    icon: <FaLinkedinIn />,
  },
];
